import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SessionService } from 'app/components/common/session/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CatalogueService } from '../catalogue/catalogue.service';
import { FiltersService } from '../filters/filters.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '../utils/utils.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-menu-tabs',
  templateUrl: './menu-tabs.component.html',
  styleUrls: ['./menu-tabs.component.css']
})
export class MenuTabsComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  tabs: Array<any> = [
    {name: 'ONLY_EXHIBITORS', value: 'exhibitors', enabled: false, displayCount:true, countValue: 'EXHIBITORS'},
    {name: 'ONLY_PRODUCTS', value: 'products', enabled: false, displayCount:true, countValue: 'PRODUCTS'},
    {name: 'ONLY_NOVELTIES', value: 'novelties', enabled: false, displayCount:true, countValue: 'NOVELTIES'},
    {name: 'ONLY_BRANDS', value: 'brands', enabled: false, displayCount:true, countValue: 'BRANDS'},
    {name: 'ONLY_MAPS', value: 'maps', enabled: false, displayCount:false, countValue: 'EXHIBITORS'}
  ];
  @Input() filter: string = 'ONLY_EXHIBITORS';
  eventData: object = {};

  private readonly destroy$ = new Subject();

  constructor(private sessionService: SessionService, private router: Router, private catalogueService: CatalogueService,
    public filtersService:FiltersService, public translateService: TranslateService, private utilsService:UtilsService,
    private activatedRoute: ActivatedRoute) {}

  getBorderColor(tab) {

    if (tab.name === this.filter) {
      return this.catalogueService.getProperty('mainColor');
    } else {
      return 'transparent';
    }

  }

  goTo(tab) {

    switch(tab.name) {
      case 'ONLY_MAPS':
        this.router.navigate([this.eventData['eventName'] + '/firamaps'], {
          queryParams: {
            lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)
          }
        });
        break;
      default:
        this.router.navigate([this.eventData['eventName'] + '/home'], {
          queryParams: {
            filter: tab.name,
            lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)
          }
        });
        break;
    }

  }

  createTabs() {
    this.tabs = [
      {name: 'ONLY_EXHIBITORS', value: 'exhibitors', enabled: this.eventData['filterExhibitors'], displayCount:true, countValue: 'EXHIBITORS'},
      {name: 'ONLY_PRODUCTS', value: 'products', enabled: this.eventData['filterProducts'], displayCount:true, countValue: 'PRODUCTS'},
      {name: 'ONLY_NOVELTIES', value: 'novelties', enabled: this.eventData['allowNovelty'], displayCount:true, countValue: 'NOVELTIES'},
      {name: 'ONLY_BRANDS', value: 'brands', enabled: this.eventData['showBrandFilter'], displayCount:true, countValue: 'BRANDS'},
      {name: 'ONLY_MAPS', value: 'maps', enabled: this.eventData['mapsActive'], displayCount:false, countValue: 'EXHIBITORS'},
    ];
  }

  fetchCatalogueDataFallback() {
    let eventCode = this.activatedRoute.snapshot.paramMap.get('event');

    if (!eventCode) {
      return;
    }

    this.catalogueService.ensureDataLoaded(eventCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: object) => {
        // Data is set by CatalogueService.ensureDataLoaded(); getData() subscription will react to it.
      },
        error => {
          console.error("[fetchCatalogueDataFallback]ERROR", error);
        });
  }

  ngOnInit() {

    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

    this.catalogueService.getData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        if (!data || !data['sapCode']) {
          this.fetchCatalogueDataFallback();
          return;
        }

        this.eventData = data;
        this.createTabs();
      });

    this.filtersService.getSelectedView()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.createTabs();
      });

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
